import {
  Container,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  MenuItem,
  Button,
  Box,
  Grid,
  Chip,
  IconButton,
} from "@mui/material";

export default function DocumentFilters({
  filters,
  setFilters,
  updateFilters,
  clearFilters
}) {
  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 3 }}>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        {/* <FilterList sx={{ mr: 1 }} color="action" /> */}
        <Typography variant="h6">Filtros</Typography>
      </Box>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={2}>
          <TextField
            fullWidth
            size="small"
            label="Cliente"
            name="search"
            type="search"
            placeholder="Buscar"
            value={filters.search}
            onChange={(e) =>
              updateFilters({
                search: e.target.value,
              })
            }
          ></TextField>
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            select
            fullWidth
            size="small"
            label="Documento"
            name="document_type"
            value={filters.document_type}
            onChange={(e) =>
              updateFilters({
                document_type: e.target.value,
              })
            }
          >
            <MenuItem value="">Todos</MenuItem>
            <MenuItem value="01">Facturas</MenuItem>
            <MenuItem value="03">Boletas</MenuItem>
            <MenuItem value="07">Nota de credito</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            select
            fullWidth
            size="small"
            label="Estado"
            name="status_sunat"
            value={filters.status_sunat}
            onChange={(e) =>
              updateFilters({
                status_sunat: e.target.value,
              })
            }
          >
            <MenuItem value="">Todos</MenuItem>
            <MenuItem value="P">Pendiente</MenuItem>
            <MenuItem value="A">Aceptado</MenuItem>
            <MenuItem value="R">Rechazada</MenuItem>
            <MenuItem value="X">Anulada</MenuItem>
          </TextField>
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            fullWidth
            size="small"
            type="date"
            label="Desde"
            InputLabelProps={{ shrink: true }}
            value={filters.from}
            onChange={(e) =>
              updateFilters({
                from: e.target.value,
              })
            }
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <TextField
            fullWidth
            size="small"
            type="date"
            label="Hasta"
            InputLabelProps={{ shrink: true }}
            value={filters.to}
            onChange={(e) =>
              updateFilters({
                to: e.target.value,
              })
            }
          />
        </Grid>
        <Grid item xs={12} sm={2}>
          <Button
            variant="outlined"
               onClick={clearFilters}
            fullWidth
          >
            Limpiar Filtros
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
}
